import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { CrossIcon } from 'assets';
import { COLORS } from 'components';

interface StepHeaderProps {
    currentStep: number;
    totalSteps: number;
    onClose: () => void;
}

export const StepHeader: React.FC<StepHeaderProps> = ({
    currentStep,
    totalSteps,
    onClose
}) =>
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            borderBottom: '1.25px solid #054254'
        }}
    >
        <Typography
            variant="body2"
            sx={{
                color: COLORS.Mainblue,
                fontSize: '14px',
                fontWeight: 500
            }}
        >
            Step {currentStep}/{totalSteps}
        </Typography>
        <IconButton
            onClick={onClose}
            size="large"
            sx={{
                padding: '8px',
                color: '#666'
            }}
        >
            <CrossIcon style={{ width: '24px', height: '24px' }} />
        </IconButton>
    </Box>
